import { render, staticRenderFns } from "./WikiHome.vue?vue&type=template&id=6020d276&scoped=true&"
import script from "./WikiHome.vue?vue&type=script&lang=js&"
export * from "./WikiHome.vue?vue&type=script&lang=js&"
import style0 from "./WikiHome.vue?vue&type=style&index=0&id=6020d276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6020d276",
  null
  
)

export default component.exports